import React, { ReactElement } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './predkladatelUpdateButtons.scss';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  onClick: () => void;
  loading: boolean;
  isAdmin: boolean;
}

const PredkladatelUpdateButtons = ({
  onClick,
  loading,
  isAdmin,
}: Props): ReactElement => (
  <div className="predkladatel-update__buttons">
    <ConfirmModal
      question="Naozaj si prajete zmeniť predkladateľa?"
      description={isAdmin ? 'Po vykonaní funkcie už nebude môcť aktuálne zvolený predkladateľ '
              + 'vykonávať pracovné kroky v rámci tohto štádia. Pracovné kroky budú priradené na vykonanie'
              + ' zvolenému používateľovi. ' : 'Po vykonaní funkcie už nebudete môcť vykonávať pracovné kroky '
              + 'v rámci tohto štádia. Pracovné kroky budú priradené na vykonanie zvolenému používateľovi.'}
      cancelButtonText="Nie"
      confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
      openButton={(
        <LoaderButton
          className="predkladatel-update__submit-button"
          loading={loading}
          type="button"
          size="large"
          disableOutsideClickWhileLoading
        >Zmeniť predkladateľa
        </LoaderButton>
          )}
      doAfterConfirm={onClick}
    />
    <BackButton buttonStyle="button" className="predkladatel-update__back-button" />
  </div>
);

export default PredkladatelUpdateButtons;
